export var days = [
    'domingo',
    'segunda-feira',
    'terça-feira',
    'quarta-feira',
    'quinta-feira',
    'sexta-feira',
    'sábado',
]

export default function formatDay(day) {
    return day >= 0 & day < 7 ? days[day]:'invalid';
}